import BreakpointController from 'controllers/breakpoint';
import ObjectFitController from 'controllers/object-fit';
import PageController from 'controllers/page';
import HeaderController from 'controllers/header';
import MenuController from 'controllers/menu';
import ModalsController from 'controllers/modals';
import HistoryController from 'controllers/history';
import MenuButtonsController from 'controllers/menu-buttons';
import ParallaxController from 'controllers/parallax';
import LazyLoadController from 'controllers/lazy-load';
import LoaderController from 'controllers/loader';
import HomeController from 'controllers/home';
import MixologyController from "controllers/mixology";
import LocationsController from 'controllers/locations';
import EventsController from 'controllers/events';
import HappeningsController from 'controllers/happenings';
import PeopleController from 'controllers/people';
import ContactController from 'controllers/contact';
// import BookATableController from 'controllers/book-a-table';
import AudioPlayersController from 'controllers/audio-players';
import Helpers from 'tools/helpers';
import Bus from 'tools/bus';
import Binder from 'tools/binder';

class AppController {
    constructor() {
        this.IEVersion = Helpers.detectIE();
        
        this.helpers = Helpers;
        this.bus = new Bus(this);
        this.binder = new Binder(this);
        
        this.isTouchDevice = false;

        this.isSafari = !! navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
        this.iOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && ! window.MSStream;

        //this.initTypekitEvents();
        
        this.attachEvents();
        
        this.addIEClasses();
        this.initControllers();
        
        // Load other pages once instantiation is complete
        this.loaderController.loadPages();
    }

    /*initTypekitEvents() {
        if (window.FLAG_TYPEKIT_LOADED_BEFORE_APP) {
            this.emitFontsLoaded();
        }
    }*/

    emitFontsLoaded() {
        this.bus.emit('fonts-loaded');
    }
    
    attachEvents() {
        window.addEventListener('touchstart', this.binder.bind('onWindowTouchStart'));
    }
    
    onWindowTouchStart() {
        document.body.classList.add('touch-enabled');

        this.isTouchDevice = true;

        this.emit('touch-enabled');
    }
    
    make(controller, ...args) {
        return new (controller.bind.apply(controller, [controller, this].concat(args)));
    }

    initControllers() {
        // Fundamental controllers
        this.breakpointController = new BreakpointController(this);
        this.pageController = new PageController(this);
        this.loaderController = new LoaderController(this);
        this.historyController = new HistoryController(this);

        // Component controllers
        this.headerController = new HeaderController(this);
        this.menuController = new MenuController(this);
        this.menuButtonsController = new MenuButtonsController(this);
        this.modalsController = new ModalsController(this);
        // this.bookATableController = new BookATableController(this);

        // Effects controllers
        this.lazyLoadController = new LazyLoadController(this);
        this.objectFitController = new ObjectFitController(this);
        this.parallaxController = new ParallaxController(this);

        // Page-specific controller
        this.homeController = new HomeController(this);
        this.mixologyController = new MixologyController(this);
        this.locationsController = new LocationsController(this);
        this.eventsController = new EventsController(this);
        this.happeningsController = new HappeningsController(this);
        this.peopleController = new PeopleController(this);
        this.contactController = new ContactController(this);

        this.audioPlayersController = new AudioPlayersController(this);

        this.bus.emit('controllers-initialised');
    }
    
    addIEClasses() {
        if (this.IEVersion) {
            document.body.classList.add('ie-browser');
            document.body.classList.add('ie-browser-' + this.IEVersion);
        }
    }
}

export default AppController;